import React from "react"
import { containerClass, tabActiveClass, tabInactiveClass, motionSafeClass } from "../../config/theme"

type Tab = { 
  href: string
  label: string
  icon?: React.ReactNode
  onClick?: () => void
}

type Props = {
  tabs: Tab[]
  activeTab?: string
}

export default function TabNav({ tabs, activeTab }: Props) {
  return (
    <div className="bg-white/60 backdrop-blur supports-[backdrop-filter]:bg-white/50 border-b border-gray-200/50">
      <div className={`${containerClass} py-3`}>
        <div className="flex flex-wrap gap-2 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => {
            const active = activeTab ? activeTab === tab.href.replace('#', '') : false
            
            if (tab.onClick) {
              return (
                <button
                  key={tab.href}
                  onClick={tab.onClick}
                  className={`inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-medium whitespace-nowrap ${motionSafeClass} ${
                    active ? tabActiveClass : tabInactiveClass
                  }`}
                >
                  {tab.icon && (
                    <span className="flex-shrink-0">
                      {tab.icon}
                    </span>
                  )}
                  {tab.label}
                </button>
              )
            }
            
            return (
              <a 
                key={tab.href} 
                href={tab.href} 
                className={`inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-medium whitespace-nowrap ${motionSafeClass} ${
                  active ? tabActiveClass : tabInactiveClass
                }`}
              >
                {tab.icon && (
                  <span className="flex-shrink-0">
                    {tab.icon}
                  </span>
                )}
                {tab.label}
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
